import React, { useEffect, useState, useContext, useMemo } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useAlert } from 'react-alert';
import { UserContext } from "../../../UserContext";

import CenteredPageContainer from "../layout_components/CenteredPageContainer";
import CenteredLoadingIcon from "../common_components/CenteredLoadingIcon";
import Button from "../common_components/Button";

import MissionHeader from "./MissionHeader";
import MissionSummary from "./MissionSummary";
import MissionContents from "./mission_contents/MissionContents";

// API Calls
import MissionAPI from "../../api/api_calls/MissionAPI";



function MissionPage(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();
    const navigate = useNavigate();
    const { missionId } = useParams();

    const [mission, setMission] = useState([]);
    const [referralLink, setReferralLink] = useState(null);
    const [referralBonusAmount, setReferralBonusAmount] = useState(null);
    const [loadMissionComplete, setLoadMissionComplete] = useState(false);


    const screenWidth = window.innerWidth;
    const isMobile = screenWidth < 840;

    useEffect(() => {
        // Grab information on this user

        async function getMissions() {
            const result = await MissionAPI.show(missionId, navigate);

            if (result.success) {
                setMission(result.mission);
                setReferralLink(result.referral_link);
                setReferralBonusAmount(result.referral_bonus_amount);
                setLoadMissionComplete(true);
            } else {
                alert.error(result.error);
                navigate("/missions");
                setLoadMissionComplete(false);
            }
        }

        getMissions();
    }, []);

    const copyReferralLink = () => {
        if (referralLink) {
            navigator.clipboard.writeText(referralLink);
            alert.success("Referral link copied!");
        }
    };

    const hasReferralBonus = referralBonusAmount && parseFloat(referralBonusAmount) > 0;

    return (
        <CenteredPageContainer noPadding={isMobile}>
            <div className="mission-page-container">
                {!loadMissionComplete ? <CenteredLoadingIcon /> :
                    <>
                        <MissionHeader mission={mission} />
                        {hasReferralBonus && referralLink && (
                            <MissionReferralBonusCard
                                referralBonusAmount={referralBonusAmount}
                                copyReferralLink={copyReferralLink}
                            />
                        )}
                        <MissionSummary mission={mission} />
                        <MissionContents mission={mission} />
                    </>
                }
            </div>
        </CenteredPageContainer>
    )
}

function MissionReferralBonusCard({ referralBonusAmount, copyReferralLink }) {
    const bonusAmount = parseFloat(referralBonusAmount).toFixed(0);

    return (
        <div className="mission-referral-bonus-card">
            <div className="mission-referral-bonus-content">
                <div className="mission-referral-bonus-title">Referral Bonus: ${bonusAmount}</div>
                <div className="mission-referral-bonus-description body-small">
                    Get your friends to sign up and complete this mission to earn an <strong>extra ${bonusAmount}</strong> (on top of the <Link to="/referrals" className="mission-referral-bonus-learn-more">base reward</Link>).
                    <br />
                    They must sign up using the link from this button. <a href="https://desparkwiki.notion.site/how-do-referrals-work?source=despark_app" target="_blank" className="mission-referral-bonus-learn-more">Learn more</a>
                </div>
            </div>
            <Button size="small" color="blue" onClick={copyReferralLink}>
                Copy referral link
            </Button>
        </div>
    );
}




export default MissionPage